import entities from './entities';
import entityFeeds from './entity-feeds';

let messages = Object.assign({}, entities, entityFeeds);

export default messages;
